module.exports = __webpack_public_path__ + "static/news (3)-e599b465c6d4e0f0818be907402d551d.jpg";